module.exports = __webpack_public_path__ + "img/translate-seven.c9073816.png";